import Dashboard from "@/components/pages/Dashboard.tsx";
import DashboardLayout from "@/layout/DashboardLayout.tsx";

export default function DashboardView() {
    return (
        <DashboardLayout>
            <Dashboard/>
        </DashboardLayout>
    );
}
